module.exports = __webpack_public_path__ + "img/Picture2.03dc8e7b.png";